import React, { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';

import { useResponsive } from '@garnish/core';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientCardLabel = (props: IngredientCardLabelProps) => {
  const { children, style, ...restProps } = props;

  const { match } = useResponsive();

  return (
    <BodyText
      sizeMatch={match([['12'], ['16'], ['22']])}
      style={[styles.text, style]}
      {...restProps}
    >
      {children}
    </BodyText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    textAlign: 'center',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type IngredientCardLabelProps = ComponentProps<typeof BodyText>;
